import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { getAccessibleInspection } from "../../const/const";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Reduxstore";

interface InspectionMainProps {
  inspectionType: string;
  setPathname: (path: string) => void;
}

const InspectionMain: React.FC<InspectionMainProps> = ({
  inspectionType,
  setPathname,
}) => {
  // Filter inspections based on user roles

  const rolls = useSelector((state:RootState)=>state.auth.role);
  const inspections = getAccessibleInspection(rolls);

  return (
    <Grid container spacing={2} padding={2}>
      {inspections.length > 0 ? (
        inspections.map((inspection, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card
              sx={{
                textAlign: "center",
                p: 2,
                boxShadow: 3,
                borderRadius: 2,
                cursor: "pointer",
              }}
              onClick={() =>
                setPathname(`/inspections/${inspection.name.toLowerCase()}`)
              }
            >
              <CardContent>
                <Typography variant="h6" fontWeight="bold">
                  {inspection.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Typography variant="h6" textAlign="center">
            No Access to Inspection
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default InspectionMain;